import axios from 'axios';
import { getApiUrl } from '../../../config/api';

/**
 * API client for Settings → Activity. The backend takes the company from the
 * signed-in identity, so nothing here sends one.
 */
export async function getActivity({ person, category, since, until, beforeId } = {}) {
  const params = new URLSearchParams();
  if (person) params.set('person', person);
  if (category) params.set('category', category);
  if (since) params.set('since', since);
  if (until) params.set('until', until);
  if (beforeId) params.set('before_id', String(beforeId));
  const query = params.toString();
  const res = await axios.get(getApiUrl(`/api/company/activity${query ? `?${query}` : ''}`), {
    withCredentials: true,
  });
  return {
    activity: Array.isArray(res.data?.activity) ? res.data.activity : [],
    nextBeforeId: res.data?.next_before_id || null,
    people: Array.isArray(res.data?.people) ? res.data.people : null,
  };
}
